---
ID: 66d6c9c6475e2a8f26f2e9ce
---

<script>
    import Loader from "$lib/components/elements/Loader.svelte"

    const blocks = [
  {
    "id": "PxGpGpFjlh",
    "type": "text",
    "html": "<p>Welcome to the&nbsp;<b><u><a href=\"https://easypagego.com/\" target=\"_blank\" rel=\"noopener noreferrer\">EasyPageGO</a></u></b>&nbsp;documentation! This guide will help you get started with this powerful no-code online editor designed to simplify the process of building&nbsp;<b>SEO-optimized</b>,&nbsp;<b>static</b>,&nbsp;<b>beautiful</b>, and&nbsp;<b>hyper-performant</b>&nbsp;documentation websites.</p>"
  },
  {
    "id": "DTIbmPPVyG",
    "type": "callout",
    "variant": "success",
    "html": "<p><i>Did you know?</i>&nbsp;This entire website is the output of&nbsp;<b>EasyPageGO</b>!</p>"
  },
  {
    "id": "Yg0mGcx3oN",
    "type": "text",
    "html": "<h2 id=\"what-is-easypagego\"><b>What is EasyPageGO?</b></h2><p><b>EasyPageGO</b>&nbsp;is an intuitive platform that allows anyone, regardless of technical skill, to create professional-grade documentation websites. It combines modern design, SEO best practices, and performance optimizations, ensuring your documentation is fast, user-friendly, and search engine-friendly.</p><p>With&nbsp;<b>EasyPageGO</b>, you can focus on writing and structuring your content without worrying about code, design, or performance.</p>"
  },
  {
    "id": "qvf7NI2Xb2",
    "type": "text",
    "html": "<h2 id=\"who-is-easypagego-for\"><b>Who is EasyPageGO for?</b></h2><p>EasyPageGO is perfect for:</p><ul><li><b>Product Teams</b>: Create beautiful product documentation with ease.</li><li><b>Developers</b>: Deliver fast, optimized sites without worrying about front-end complexity.</li><li><b>Content Creators</b>: Focus on content and leave the technical aspects to EasyPageGO.</li></ul><h2 id=\"why-choose-easypagego\"><b>Why Choose EasyPageGO?</b></h2><ul><li><b>Speed</b>: Our static site generation ensures near-instant load times, improving user experience and search engine rankings.</li><li><b>Simplicity</b>: You don’t need to know code or have technical expertise. Our platform is designed to make website creation effortless.&nbsp;The only lines of code you will (eventually) write are the ones you put in the&nbsp;<u><a href=\"https://docs.easypagego.com/editor/codeblocks/\" target=\"_blank\" rel=\"noopener noreferrer\">codeblock</a></u>&nbsp;element.</li><li><b>SEO Best Practices</b>: Built-in tools to guide you through optimizing your site for search engines.</li><li><b>Customization</b>: You have the right amount of control, enough to make the final output your own, not enough to have to go into technicalities. It looks good always, on all devices.</li></ul>"
  },
  {
    "id": "cd2jiKWQAX",
    "type": "card",
    "items": [
      {
        "id": "VC8MT2rF6V",
        "title": "Editor",
        "html": "<p>Learn about the&nbsp;<b>no-code editor</b>&nbsp;to create and organize your content effortlessly. Learn how to use shortkeys, how to customize styles, structure pages, and make the most of EasyPageGO's powerful editing features.</p><p><u><a href=\"https://docs.easypagego.com/editor/\" target=\"_blank\" rel=\"noopener noreferrer\">Read about the editor</a></u></p>"
      },
      {
        "id": "SdQTO7TDgF",
        "title": "Website Structure",
        "html": "<p>Understand how your documentation site is built, which&nbsp;<b>files</b>&nbsp;are&nbsp;<b>automatically generated</b>, and how the&nbsp;<b>UI elements</b>&nbsp;are&nbsp;<b>computed</b>&nbsp;from the content you provide. This section covers the mechanics of your website's structure and layout.</p><p><u><a href=\"https://docs.easypagego.com/website-structure/\" target=\"_blank\" rel=\"noopener noreferrer\">Learn about your website</a></u></p>"
      },
      {
        "id": "W_eY-zdDTo",
        "title": "Deployment",
        "html": "<p>Finally, see how simple it is to obtain your final optimized website. This section explains the build system, covering everything from the build output to detailed guides on deploying your static site to various platforms.</p><p><u><a href=\"https://docs.easypagego.com/deployment/\" target=\"_blank\" rel=\"noopener noreferrer\">Discover the easy deployment</a></u></p>"
      }
    ]
  }
];
</script>

{#each blocks as block}
<Loader {block}/>
{/each}